// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1tsWq","colCheckbox":"styles_colCheckbox__1uZC1"};